import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de commission - Calculez les commissions sur ventes";
const DESCRIPTION =
  "Calculatrice de commission gratuite : calculez le montant de votre commission sur les ventes, le total apres commission et le montant net. Outil pour commerciaux, agents et independants.";
const KEYWORDS =
  "calculatrice commission, calcul commission vente, commission commercial, pourcentage commission, remuneration variable";
const OG_URL = "https://do-calculate.com/calculator/fr/commission-calculator/";

const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Calculatrice de commission",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "FinancialApplication",
    operatingSystem: "Any",
    offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
  },
];

function CommissionCalculator() {
  const [baseAmount, setBaseAmount] = useState("");
  const [commissionRate, setCommissionRate] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateCommission = () => {
    try {
      setError("");
      const amount = parseFloat(baseAmount);
      const rate = parseFloat(commissionRate);
      const qty = parseInt(quantity) || 1;

      if (isNaN(amount) || isNaN(rate)) { setResult(null); return; }
      if (amount < 0 || rate < 0) {
        setError("Veuillez entrer des valeurs positives");
        setResult(null); return;
      }

      const totalSales = amount * qty;
      const commissionAmount = (totalSales * rate) / 100;
      const remainingAmount = totalSales - commissionAmount;

      setResult({ totalSales, commissionAmount, remainingAmount, rate, qty });
    } catch (err) {
      setError("Erreur de calcul");
      setResult(null);
    }
  };

  useEffect(() => { calculateCommission(); }, [baseAmount, commissionRate, quantity]);

  const handleClear = () => {
    setBaseAmount(""); setCommissionRate(""); setQuantity(1); setResult(null); setError("");
  };

  return (
    <div className="ltr" style={{ direction: "ltr" }}>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} SCHEMA={SCHEMA} />
      <div className="row"><div className="col-12 col-md-8"><FirstAds /></div></div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ padding: "15px", borderRadius: "5px" }}>
            <h1 style={{ fontSize: "22px", margin: 0 }}>Calculatrice de commission</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                La <strong>calculatrice de commission</strong> est un outil financier indispensable pour tout
                commercial, vendeur ou responsable souhaitant <strong>calculer les commissions</strong> avec
                precision. Que vous travailliez dans l&apos;immobilier, le e-commerce ou la vente directe,
                cet outil vous aide a connaitre vos droits instantanement.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Entrez les donnees de vente</h2>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label>Prix unitaire / Montant de base</label>
                  <input type="number" className="form-control" value={baseAmount}
                    onChange={(e) => setBaseAmount(e.target.value)} placeholder="Ex: 1000" />
                </div>
                <div className="col-sm-12 col-md-6">
                  <label>Taux de commission (%)</label>
                  <input type="number" className="form-control" value={commissionRate}
                    onChange={(e) => setCommissionRate(e.target.value)} placeholder="Ex: 5" />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-sm-12 col-md-6">
                  <label>Quantite (nombre de ventes)</label>
                  <input type="number" className="form-control" value={quantity}
                    onChange={(e) => setQuantity(e.target.value)} min="1" />
                </div>
              </div>
              <div className="text-center mb-3 mt-4">
                <button onClick={handleClear} className="btn btn-secondary" style={{ fontSize: "16px", padding: "10px 30px" }}>
                  Effacer les donnees
                </button>
              </div>
              {error && <div className="alert alert-warning"><strong>Attention :</strong> {error}</div>}
              {result && (
                <div className="mt-4">
                  <h3 style={{ fontSize: "18px", marginBottom: "15px", textAlign: "center" }}>
                    <strong>Resultats du calcul :</strong>
                  </h3>
                  <table className="table bmi-table" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Element</th>
                        <th style={{ textAlign: "center" }}>Valeur</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }}>Chiffre d&apos;affaires total</td>
                        <td style={{ textAlign: "center", fontWeight: "bold" }}>
                          {result.totalSales.toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: "center" }}>Commission due</td>
                        <td style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#1a5f3f" }}>
                          {result.commissionAmount.toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: "center" }}>Montant net apres commission</td>
                        <td style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#0f3d28" }}>
                          {result.remainingAmount.toLocaleString()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header"><strong>Detail du calcul</strong></div>
                      <div className="info-section-body">
                        <p>Commission = (Chiffre d&apos;affaires total x Taux de commission) / 100</p>
                        <p>Calcul : ({result.totalSales} x {result.rate}%) = {result.commissionAmount}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row"><RelatedLinks /></div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds /><br />
          <MainCalculatorsList />
        </div>
      </div>

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Comment utiliser la calculatrice de commission ?</div>
              <div className="info-section-body">
                <p><strong>Etapes d&apos;utilisation :</strong></p>
                <ul>
                  <li>Entrez le prix du produit ou service vendu.</li>
                  <li>Definissez le taux de commission convenu (ex: 5% ou 10%).</li>
                  <li>Entrez le nombre d&apos;unites vendues dans la case quantite.</li>
                  <li>La calculatrice affiche automatiquement le montant de commission et le solde net.</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Utilisations pratiques de la calculatrice</div>
              <div className="info-section-body">
                <ul>
                  <li><strong>Agents immobiliers :</strong> calculer la commission sur une vente ou une location.</li>
                  <li><strong>Commerciaux :</strong> suivre les gains mensuels selon les objectifs atteints.</li>
                  <li><strong>E-commerce :</strong> calculer les frais de plateforme (Amazon, marketplaces).</li>
                  <li><strong>Marketing d&apos;affiliation :</strong> estimer les revenus sur la promotion de liens.</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Notions cles sur les systemes de commission</div>
              <div className="info-section-body">
                <table className="table bmi-table">
                  <thead>
                    <tr><th>Type</th><th>Description</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>Commission fixe</td><td>Montant fixe par vente, independamment du prix.</td></tr>
                    <tr><td>Pourcentage</td><td>Part du montant total de la facture.</td></tr>
                    <tr><td>Commission progressive</td><td>Le taux augmente avec le volume de ventes.</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Exemples pratiques de calcul de commission</div>
              <div className="info-section-body">
                <p><strong>Exemple 1 :</strong> Un vendeur d&apos;electromenager vend un lave-linge a 800 € avec une commission de 3%. Commission = 800 x 0,03 = 24 €.</p>
                <p><strong>Exemple 2 :</strong> Un agent immobilier vend un appartement a 250 000 € avec un taux de 2,5%. Commission = 250 000 x 0,025 = 6 250 €.</p>
                <p><strong>Exemple 3 :</strong> Vente de 10 articles a 100 € avec 10% de commission. CA total = 1 000 €, commission = 100 €.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Conseils pour un calcul de commission precis</div>
              <div className="info-section-body">
                <ul>
                  <li>Verifiez toujours si le taux s&apos;applique avant ou apres la TVA — la base de calcul peut varier selon le contrat.</li>
                  <li>Conservez un registre precis de toutes vos factures pour les reconcilier avec les resultats de la calculatrice.</li>
                  <li>En cas de retour marchandise, deduisez ces montants de votre chiffre d&apos;affaires total avant de calculer la commission finale.</li>
                  <li>Soyez attentif aux decimales dans les taux eleves pour eviter des ecarts financiers sur de grands volumes.</li>
                  <li>Pour les commissions progressives, calculez chaque tranche separement puis additionnez les resultats.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>Questions frequentes</h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment calculer manuellement ma commission sur les ventes ?</h3></div>
              <div className="info-section-body">
                Pour calculer une commission manuellement, multipliez le chiffre d&apos;affaires total par le taux en pourcentage, puis divisez par 100. Exemple : si vous vendez 5 000 € de marchandises avec un taux de 2 %, multipliez 5 000 par 2 pour obtenir 10 000, puis divisez par 100 : votre commission est de 100 €. Cette methode classique vous permet de verifier rapidement votre gain sur chaque vente.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Quel est le taux de commission habituel dans l&apos;immobilier ?</h3></div>
              <div className="info-section-body">
                En France, le taux de commission des agents immobiliers varie generalement entre 3 % et 8 % du prix de vente selon l&apos;agence et la region. Ce montant est souvent inclus dans le prix affiché (honoraires d&apos;agence) et peut etre a la charge de l&apos;acheteur ou du vendeur selon le mandat signe. Il est imperatif de formaliser ce taux dans le contrat de mandat pour proteger toutes les parties.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>La commission se calcule-t-elle sur le prix total ou sur le benefice ?</h3></div>
              <div className="info-section-body">
                Dans la grande majorite des contrats commerciaux, la commission est calculee sur le chiffre d&apos;affaires brut (prix de vente total hors TVA). Certaines entreprises preferent cependant baser la commission sur la marge (difference entre prix de vente et cout de revient) pour inciter les commerciaux a vendre a des prix plus eleves. Les deux methodes sont valides ; l&apos;essentiel est de le preciser clairement dans le contrat.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Qu&apos;est-ce qu&apos;un systeme de commission progressive ?</h3></div>
              <div className="info-section-body">
                Un systeme de commission progressive (ou par paliers) augmente le taux de commission a mesure que le volume de ventes croit. Exemple : 5 % sur les premiers 10 000 € de ventes, puis 7 % au-dela. Ce systeme motive les commerciaux a depasser leurs objectifs en offrant une recompense croissante. Il faut calculer chaque tranche separement pour obtenir la commission totale correcte.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment traiter la TVA dans le calcul de commission ?</h3></div>
              <div className="info-section-body">
                La regle generale est de calculer la commission sur le montant hors TVA. Si un produit est vendu 100 € HT + 20 € de TVA = 120 € TTC, la commission s&apos;applique sur les 100 € uniquement. Calculer sur le montant TTC gonflerait artificiellement la base et creer un desequilibre comptable, car la TVA est reversee a l&apos;Etat et ne constitue pas un revenu pour l&apos;entreprise.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Existe-t-il un plafond legal pour les commissions en France ?</h3></div>
              <div className="info-section-body">
                En France, il n&apos;existe pas de plafond legal general sur les commissions commerciales, sauf dans certains secteurs reglementes (immobilier, assurance, mutuelles). Les taux sont librement negocies entre les parties dans le cadre d&apos;un accord contractuel, sous reserve de respecter le droit du travail pour les salaries et les reglementations sectorielles applicables.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Quelle est la difference entre commission et prime (bonus) ?</h3></div>
              <div className="info-section-body">
                La commission est directement liee a chaque vente individuelle — c&apos;est un revenu variable recurrent calcule sur chaque transaction. La prime ou bonus est un complement exceptionnel verse lors de l&apos;atteinte d&apos;un objectif global (trimestriel, annuel) ou d&apos;une performance remarquable. La commission est le moteur quotidien du commercial tandis que la prime recompense la performance globale sur une periode donnee.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment gerer la commission sur les retours de marchandises ?</h3></div>
              <div className="info-section-body">
                Lorsqu&apos;un client retourne un produit, la commission versee pour cette vente doit etre reprise sur les prochains versements du commercial. Les entreprises effectuent generalement une compensation mensuelle : on additionne toutes les commissions brutes du mois, on deduit les commissions correspondant aux retours, et on verse le solde net. Cela garantit de ne remunerer que les ventes definitives et reellement encaissees.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommissionCalculator;
